import { connect, disconnect, authenticate } from '@/service/websocket.service'

export default store => {
    let currentBackendUrl = null
    let currentBaseToken = null
    let currentSharingToken = null
    let lastLiveState = false

    store.watch(
        state => ({
            live: store.getters['map/liveUpdatesEnabledConditionally'],
            baseToken: state.auth.jwt?.access,
            sharingToken: state.route?.params?.token, // adjust if route is elsewhere in your store
            backend: state.auth.backend,
        }),
        ({ live, baseToken, sharingToken, backend }) => {
            const backendUrl = backend?.websocket_url

            // disable all
            if (!live) {
                disconnect()
                currentBackendUrl = null
                currentBaseToken = null
                currentSharingToken = null
                lastLiveState = false
                return
            }

            // backend change → full reconnect
            if (backendUrl && backendUrl !== currentBackendUrl) {
                connect(backendUrl, store)
                currentBackendUrl = backendUrl

                currentBaseToken = null
                currentSharingToken = null
            }

            // initial connect if needed
            if (!currentBackendUrl && backendUrl) {
                connect(backendUrl, store)
                currentBackendUrl = backendUrl
            }

            // base token logic (equivalent to subscribeToBaseUpdates)
            if (!baseToken) {
                currentBaseToken = null
            } else if (baseToken !== currentBaseToken || !lastLiveState) {
                authenticate(baseToken)
                currentBaseToken = baseToken
            }

            // sharing token logic (equivalent to subscribeToSharingUpdates)
            if (!sharingToken) {
                currentSharingToken = null
            } else if (sharingToken !== currentSharingToken || !lastLiveState) {
                authenticate(sharingToken)
                currentSharingToken = sharingToken
            }

            lastLiveState = live
        },
        { immediate: true }
    )
}
